module.exports = __webpack_public_path__ + "img/logo13.ebbe651b.jpg";